async function fetchWholesalePricing(productId, variantIds) {
  const customerEmail = window.GSOWholesaleCustomer?.email || "";

  const url =
    `/apps/wholesale-lite/pricing` +
    `?product_id=${encodeURIComponent(productId)}` +
    `&variant_ids=${encodeURIComponent(variantIds.join(","))}` +
    `&customer_email=${encodeURIComponent(customerEmail)}`;

  const res = await fetch(url);
  return await res.json();
}

function money(value) {
  return `$${Number(value || 0).toFixed(2)}`;
}

function applyWholesalePricing(data) {
  if (!data || !data.ok) return;

  const tiersByVariant = data.tiersByVariant || {};
  const customerTags = data.customerTags || [];

  console.log("GSO Wholesale data:", data);

  const box = document.querySelector(".gso-wholesale-box");
  if (box) {
    box.querySelector(".gso-customer-tags").textContent =
      customerTags.length ? customerTags.join(", ") : "none";
  }

  Object.keys(tiersByVariant).forEach((variantId) => {
    const rules = tiersByVariant[variantId];
    if (!rules || rules.length === 0) return;

    const bestRule = rules[rules.length - 1];

    let displayPrice = bestRule.value;

    if (bestRule.discountType === "PERCENT_OFF" || bestRule.discountType === "AMOUNT_OFF") {
      const retailPriceEl =
        document.querySelector("[data-product-price]") ||
        document.querySelector(".price") ||
        document.querySelector(".product__price");

      const retailText = retailPriceEl?.textContent?.replace(/[^0-9.]/g, "") || "0";
      const retail = Number(retailText);

      if (bestRule.discountType === "PERCENT_OFF") {
        displayPrice = retail * (1 - bestRule.value / 100);
      }

      if (bestRule.discountType === "AMOUNT_OFF") {
        displayPrice = Math.max(0, retail - bestRule.value);
      }
    }

    const priceText = `${money(displayPrice)} Wholesale`;

    const priceTargets = [
      document.querySelector("[data-product-price]"),
      document.querySelector(".price"),
      document.querySelector(".product__price"),
      document.querySelector(".price__regular"),
      document.querySelector(".price-item--regular"),
    ].filter(Boolean);

    priceTargets.forEach((el) => {
      el.textContent = priceText;
    });

    if (box) {
      const tbody = box.querySelector(".gso-tier-body");
      if (tbody) {
        tbody.innerHTML = rules
          .map(
            (rule) => `
              <tr>
                <td>${rule.minQuantity}+</td>
                <td>${rule.discountType === "FIXED_PRICE" ? money(rule.value) : `${rule.value} ${rule.discountType}`}</td>
                <td>${rule.title}</td>
              </tr>
            `
          )
          .join("");
      }

      const activeRule = box.querySelector(".gso-active-rule");
      if (activeRule) activeRule.textContent = bestRule.title || "Wholesale rule";

      const unitPrice = box.querySelector(".gso-unit-price");
      if (unitPrice) unitPrice.textContent = money(displayPrice);

      const moq = box.querySelector(".gso-moq");
      if (moq) moq.textContent = bestRule.minProductQuantity || bestRule.minQuantity || 1;
    }
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  if (!window.meta || !window.meta.product) {
    console.warn("GSO Wholesale: window.meta.product not found.");
    return;
  }

  const product = window.meta.product;
  const productId = product.id;
  const variantIds = product.variants.map((v) => v.id);

  const data = await fetchWholesalePricing(productId, variantIds);
  applyWholesalePricing(data);
});